import Main, { getInitialProps } from './Main';
import { useViewModel } from './viewModel';

export default {
    Main,
    useViewModel,
    getInitialProps,
};
